/**
 * Tradução dos sinais de relevância (SPEC-015 §9).
 *
 * Ranking opaco em pesquisa que vira relatório é ranking em que ninguém
 * confia, e a primeira pergunta de quem lê o resultado é sempre "por que isto
 * está em primeiro?". O domínio devolve nomes de sinal; a tela os traduz —
 * texto de interface não mora no domínio (§50).
 */
const SIGNAL_LABELS: Record<string, string> = {
  termMatch: 'contém os termos buscados',
  phraseMatch: 'contém a frase exata',
  hashtagMatch: 'usa as hashtags buscadas',
  recency: 'publicado perto do fim do período',
  engagement: 'teve bastante interação',
  profileMatch: 'de um perfil que você confirmou',
  recurrence: 'o autor aparece várias vezes neste recorte',
  coOccurrence: 'traz mais de um termo na mesma frase',
};

export function signalLabel(signal: string): string {
  return SIGNAL_LABELS[signal] ?? signal;
}

/**
 * Os sinais que mais contribuíram, do maior para o menor. Espelha `topSignals`
 * do domínio, mas sobre o registro já serializado que a API devolve.
 */
export function topSignalNames(signals: Record<string, number> | null, limit = 3): string[] {
  if (signals === null) return [];
  return Object.entries(signals)
    .filter(([, contribution]) => contribution > 0)
    .sort(([, a], [, b]) => b - a)
    .slice(0, limit)
    .map(([signal]) => signal);
}

/** Frase pronta para a tela; vazia quando não há sinal que explique. */
export function explainRelevance(signals: Record<string, number> | null): string {
  const top = topSignalNames(signals);
  if (top.length === 0) return '';
  return top.map(signalLabel).join('; ');
}
